<template>
  <!-- Navbar Start -->
  <nav class="navbar" id="navbar">
    <div class="container flex flex-wrap items-center justify-end">
      <router-link class="navbar-brand" to="/">
        <img :src="logo" class="h-24" alt="Sultan Flowers Extracts Place" decoding="async" />
      </router-link>

      <div class="nav-icons flex items-center lg_992:order-2 ms-auto">
        <!-- Navbar Button -->
        <ul class="list-none menu-social mb-0">
          <li class="inline">
            <a href="https://www.tiktok.com/@sultan_flowers111" target="_blank" rel="noopener noreferrer"
               aria-label="TikTok"
               class="btn btn-sm btn-icon rounded-full bg-orange-600 hover:bg-orange-700 border-orange-600
               hover:border-orange-700 text-white"><svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"
                                                        aria-hidden="true"><path
                d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg></a>
          </li>
          <li class="inline">
            <a href="https://wa.me/201004379550" target="_blank" rel="noopener noreferrer"
               aria-label="WhatsApp"
               class="btn btn-sm btn-icon rounded-full bg-orange-600 hover:bg-orange-700 border-orange-600
               hover:border-orange-700 text-white"><i
                class="uil uil-whatsapp"></i></a>
          </li>
          <li class="inline">
            <a href="https://www.instagram.com/sultanflowers_extractspalace" target="_blank" rel="noopener noreferrer"
               aria-label="Instagram"
               class="btn btn-sm btn-icon rounded-full bg-orange-600 hover:bg-orange-700 border-orange-600
               hover:border-orange-700 text-white"><i
                class="uil uil-instagram"></i></a>
          </li>
        </ul>
        <!-- Navbar Collapse Manu Button -->
        <button data-collapse="menu-collapse" type="button" @click="toggleMenu"
                class="collapse-btn inline-flex items-center ms-3 text-dark dark:text-white lg_992:hidden"
                aria-controls="menu-collapse" :aria-expanded="menuOpen">
          <span class="sr-only">Navigation Menu</span>
          <i class="mdi mdi-menu mdi-24px"></i>
        </button>
      </div>

      <!-- Navbar Manu -->
      <div class="navigation lg_992:order-1 lg_992:flex" id="menu-collapse" :class="{ hidden: !menuOpen }">
        <ul class="navbar-nav nav-light" id="navbar-navlist">
          <li v-for="link in navLinks" :key="link.target" class="nav-item" :class="{ active: active === link.target }">
            <a class="nav-link" href="javascript:void(0);" @click="scrollToSection(link.target)">{{ link.label }}</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- Navbar End -->
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import logo from '@/assets/logo.png'

const navLinks = [
  { target: '#home', label: 'Home' },
  { target: '#about', label: 'About us' },
  { target: '#features', label: 'Services' },
  { target: '#review', label: 'Review' },
  { target: '#customer_reviews', label: 'Customer Reviews' },
];

const active = ref('#home');
const menuOpen = ref(false);

function onScroll() {
  const scrolled = document.documentElement.scrollTop || document.body.scrollTop;

  // The back-to-top button is rendered by SwitcherSection
  const backToTop = document.getElementById('back-to-top');
  if (backToTop) {
    backToTop.classList.toggle('block', scrolled > 500);
    backToTop.classList.toggle('hidden', scrolled <= 500);
  }
}

function scrollToSection(selector) {
  active.value = selector;
  document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function toggleMenu() {
  menuOpen.value = !menuOpen.value;
}

onMounted(() => {
  document.documentElement.classList.add('light');
  document.documentElement.setAttribute('dir', 'ltr');
  document.body.classList.add('font-rubik', 'text-base', 'text-slate-900', 'dark:text-white', 'dark:bg-slate-900');

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // reflect the position the page was restored at
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll);
});
</script>
